import { axiosInstance } from "@/resources/requestInfo";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { trainingRoutes } from "./routes";
import { SendPersonalTrainingOrderPayload, SendSchoolTrainingOrderPayload } from "./types";

export const sendSchoolTrainingOrder = createAsyncThunk<void, SendSchoolTrainingOrderPayload>(
  "training/sendSchoolTrainingOrder",
  async (data, { rejectWithValue }) => {
    try {
      await axiosInstance.post(trainingRoutes.SEND_SCHOOL_TRAINING_ORDER, data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
)

export const sendPersonalTrainingOrder = createAsyncThunk<void, SendPersonalTrainingOrderPayload>(
  "training/sendPersonalTrainingOrder",
  async (data, { rejectWithValue }) => {
    try {
      await axiosInstance.post(trainingRoutes.SEND_PERSONAL_TRAINING_ORDER, data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
)